import { call, put, takeLatest } from "redux-saga/effects";
import {
  addTransferPatientFailure,
  addTransferPatientSuccess,
  deleteTransferPatientFailure,
  deleteTransferPatientSuccess,
  fetchHistoryTransferPatientFailure,
  fetchHistoryTransferPatientSuccess,
  fetchTransferPatientFailure,
  fetchTransferPatientMemberFailure,
  fetchTransferPatientMemberSuccess,
  fetchTransferPatientSuccess,
  updateTransferPatientFailure,
  updateTransferPatientSuccess
} from "./transferPatientAction";
import {
  addTransferPatientEffect,
  deleteTransferPatientEffect,
  editTransferPatientEffect,
  historyTransferPatientEffect,
  listTransferPatientEffect,
  ViewTransferPatientEffect,
} from "./transferPatientEffect";
import {
  ADD_TRANSFER_PATIENT_REQUEST,
  DELETE_TRANSFER_PATIENT_REQUEST,
  FETCH_LIST_TRANSFER_PATIENT_REQUEST,
  FETCH_TRANSFER_PATIENT_REQUEST,
  HISTORY_TRANSFER_PATIENT_REQUEST,
  UPDATE_TRANSFER_PATIENT_REQUEST
} from "./transferPatientType";

function* fetchTransferPatientsSaga(action) {
  try {
    const transferPatients = yield call(listTransferPatientEffect, action.payload);
    yield put(fetchTransferPatientSuccess(transferPatients));
  } catch (error) {
    yield put(fetchTransferPatientFailure(error.message));
  }
}
function* fetchGHistoryTransferPatientsSaga(action) {
  try {
    const transferPatients = yield call(historyTransferPatientEffect, action.payload);
    yield put(fetchHistoryTransferPatientSuccess(transferPatients));
  } catch (error) {
    yield put(fetchHistoryTransferPatientFailure(error.message));
  }
}
function* fetchTransferPatientSaga(action) {

  try {
    const transferPatient = yield call(ViewTransferPatientEffect, action.payload.transferPatientId ,action.payload.pageNo);
    
    yield put(fetchTransferPatientMemberSuccess(transferPatient));
  } catch (error) {
    yield put(fetchTransferPatientMemberFailure(error.message));
  }
}

function* addTransferPatientSaga(action) {
  try {
      const response = yield call(addTransferPatientEffect, action.payload);
      const transferPatientData = response.data || response; 
      yield put(addTransferPatientSuccess(transferPatientData));
  } catch (error) {

      const backendMessage = error.response?.data?.message || error.message || "Failed to add transfer patient";
      yield put(addTransferPatientFailure(backendMessage));
  }
}
function* updateTransferPatientSaga(action) {
  try {
    const updatedTransferPatient = yield call(
      editTransferPatientEffect,
      action.payload.transferPatientId,
      action.payload.transferPatientData
    );
    yield put(updateTransferPatientSuccess(updatedTransferPatient));
  } catch (error) {

    const backendMessage = error.response?.data?.message || error.message || "failed";
    yield put(updateTransferPatientFailure(backendMessage|| 'Failed to Update transfer patient'));
  }
}

function* deleteTransferPatientSaga(action) {
  try {
    yield call(deleteTransferPatientEffect, action.payload.transferPatientId);
    yield put(deleteTransferPatientSuccess(action.payload.transferPatientId));
  } catch (error) {
    yield put(deleteTransferPatientFailure(error.message));
  }
}

export function* TransferPatientSagas() {

  yield takeLatest(FETCH_LIST_TRANSFER_PATIENT_REQUEST, fetchTransferPatientsSaga);
  yield takeLatest(FETCH_TRANSFER_PATIENT_REQUEST, fetchTransferPatientSaga);
  yield takeLatest(ADD_TRANSFER_PATIENT_REQUEST, addTransferPatientSaga);
  yield takeLatest(UPDATE_TRANSFER_PATIENT_REQUEST, updateTransferPatientSaga);
  yield takeLatest(DELETE_TRANSFER_PATIENT_REQUEST, deleteTransferPatientSaga);
  yield takeLatest(HISTORY_TRANSFER_PATIENT_REQUEST, fetchGHistoryTransferPatientsSaga);
}